import { zhTW } from "../../../../date-fns/locale/zh-TW.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    zhTW
  }
};